import styled from 'styled-components';

const Style = styled.div`
  display: flex;
  position: relative;
  flex: 1;

  .react-flow__node-default .react-flow__handle {
    background: transparent;
    border-color: transparent;
  }

  .react-flow__node-default {
    border: 0px;
    box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06);
  }

  .cont {
    flex: 1;
  }

  .node {
    cursor: pointer;

    * {
      cursor: pointer;
    }
  }

  .react-flow__node-default .react-flow__handle {
    opacity: 0;
  }

  .empty-state {
    height: 600px;
    width: 100%;
    background: #F9FAFB;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .message {
      width: 272px;
      margin-left: auto;
      margin-right: auto;
      text-align: center;

      img {
        margin-bottom: 32px;
      }

      h2 {
        font-size: 18px;
        line-height: 20px;
        font-weight: 700;
        color: #101828;
        margin-bottom: 8px;
      }

      p {
        font-size: 12px;
        line-height: 14px;
        color: #6C737F;
        font-weight: 500;
        width: 252px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: var(--size-lg);
      }
    }
  }

  .ant-btn {
    margin-left: auto;
    margin-right: auto;
  }
`;

export const DropDown = styled.div`
  position: absolute;
  top: -6px;
  padding-left: 12px;
  display: flex;
  right: 0px;
  z-index: 100;
  background: white;
  
  label {
    font-size: 14px;
    margin-right: 12px;
    margin-top: 4px;
    margin-bottom: 0px;
  }

  .ant-select-selection-item {
    text-align: left;
  }
`;

export const InnerStyle = styled.div`
  display: flex;
  flex-direction: column;

  label {
    text-align: left;
    margin: 0px;
  }

  .header-cont {
    opacity: 0.4;
    display: flex;
    margin-bottom: 0px !important;
    padding: 8px 6px;
    transition: .4s opacity;

    &.active {
      opacity: 1;
    }

    .checkbox-c {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .ant-checkbox {
      transform: scale(0.7);
    }

    .header {
      display: flex;
      flex-direction: column;
      flex: 1;

      .type {
        font-size: 6px;
        font-weight: 700;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 110px;
      }

      .label {
        font-size: 9px;
        font-weight: 500;
        color: #101828;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 110px;
      }
    }
  }
`;

export default Style;
